var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero-section',{attrs:{"id":"hero-section"}}),_c('company-profile',{attrs:{"id":"company-profile"}}),_c('industry-experience',{attrs:{"id":"industry-experience"}}),_c('case-shows',{attrs:{"id":"case-shows"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }